import { render, staticRenderFns } from "./UserStory.vue?vue&type=template&id=bacdc982&scoped=true"
import script from "./UserStory.vue?vue&type=script&lang=js"
export * from "./UserStory.vue?vue&type=script&lang=js"
import style0 from "./UserStory.vue?vue&type=style&index=0&id=bacdc982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacdc982",
  null
  
)

export default component.exports